/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable import/no-cycle, no-useless-catch */
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { authUseCase, userUseCase } from '@/usecase'
import apiUseCase from '@/usecase/apiUseCase'
import { iPayloadGetToken, iPayloadLogin } from '@/utils/interfaces/iLogin'
import { IPayloadOtp } from '@/utils/interfaces/iUserResponse'
import moment from 'moment'
import { ActionTree } from 'vuex'
import { boolean } from 'yup'
import environment from '@/configs/environtment'
import { IRootState } from './model'

const actions: ActionTree<IRootState, IRootState> = {
  setToggleMenu: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_MENU', toggle)
  },
  initResize: ({ commit }) => {
    window.addEventListener('resize', () => {
      commit('SET_WIDTH', window.innerWidth)
      commit('SET_HEIGHT', window.innerHeight)
    })
  },
  initNetworkOn: ({ commit }) => {
    window.addEventListener('online', () => {
      commit('SET_CONNECTION', true)
    })
  },
  initNetworkOff: ({ commit }) => {
    window.addEventListener('offline', () => {
      commit('SET_CONNECTION', false)
      commit('SET_NO_INTERNET_MODAL', true)
    })
  },
  setWidth: ({ commit }) => {
    commit('SET_WIDTH', window.innerWidth)
  },
  setHeight: ({ commit }) => {
    commit('SET_HEIGHT', window.innerHeight)
  },
  destroyResize: ({ commit }) => {
    window.removeEventListener('resize', () => ({}))
  },
  setNoInternet: ({ commit }, noInternet: boolean) => {
    commit('SET_NO_INTERNET_MODAL', noInternet)

    if (noInternet) {
      commit('SET_SHOW_LOADING', false)
    }
  },
  showLoading: ({ commit }) => {
    commit('SET_SHOW_LOADING', true)
  },
  hideLoading: ({ commit }) => {
    commit('SET_SHOW_LOADING', false)
  },
  setToggleMenuSidebar: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_SIDEBAR', toggle)
  },
  // Components Data Table
  setShowModal: ({ commit }, showModal: boolean) => {
    commit('SET_SHOW_MODAL', showModal)
  },
  storeRowDataTable: ({ commit }, data: any) => {
    commit('STORE_ROW_DATA_TABLE', data)
  },
  flushRowDataTable: ({ commit }) => {
    commit('FLUSH_ROW_DATA_TABLE', null)
  },
  setTitleFormSidebar: ({ commit }, title: string) => {
    commit('SET_TITLE_FORM_SIDEBAR', title)
  },
  setReloadDataTable: ({ commit }) => {
    commit('SET_RELOAD_DATA_TABLE', true)
  },
  // Components Data List (DL: Data List)
  setShowModalFormDl: ({ commit }, show: boolean) => {
    commit('SET_SHOW_MODAL_FORM_DL', show)
  },
  storeRowDataListDl: ({ commit }, rowData: any) => {
    commit('STORE_ROW_DATA_LIST_DL', rowData)
  },
  setTitleFormSidebarDl: ({ commit }, title: string) => {
    commit('SET_TITLE_FORM_SIDEBAR_DL', title)
  },
  setShowModalConfirmationDl: ({ commit }, show: boolean) => {
    commit('SET_SHOW_MODAL_CONFIRMATION_DL', show)
  },
  setContentModalConfirmationDl: ({ commit }, data: any) => {
    commit('SET_CONTENT_MODAL_CONFIRMATION_DL', data)
  },
  setReloadDataList: ({ commit }) => {
    commit('SET_RELOAD_DATA_LIST', true)
  },
  flushRowDataList: ({ commit }) => {
    commit('STORE_ROW_DATA_LIST_DL', null)
  },
  // this action works to setting process all login process
  loginProcess: async ({ commit }, data: iPayloadLogin) => {
    try {
      // const response = await authUseCase.sendingLoginChallenge(data.login_challenge, data.username, data.password)
      const response = await authUseCase.loginAttempt(data.username, data.password)
      if (!response.error) {
        const date = moment()
        localStorage.setItem('ut', response.result.access_token)
        localStorage.setItem('tt', response.result.token_type)
        localStorage.setItem('it', response.result.Id)
        localStorage.setItem('ei', date.toString())
        return response
      } throw response
    } catch (error) {
      throw error
    }
  },
  logoutAccount: async ({ commit }, userId: string) => {
    console.log('logout')
    const token = localStorage.getItem('ut')
    if (token) {
      try {
        // https://identity.harapan-jaya.com/realms/dev/protocol/openid-connect/logout
        const idToken = localStorage.getItem('it')
        const url = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/logout`
        // await apiUseCase.get(`${url}?id_token_hint=${idToken}&post_logout_redirect_uri=/login`).then((response) => {
        //   console.log('resLogout', response)
          localStorage.removeItem('ut')
          localStorage.removeItem('it')
          localStorage.removeItem('ei')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('rn')
          localStorage.removeItem('tt')
          localStorage.removeItem('rt')
          commit('SET_USER_PROFILE', null)
        // })
        const params = new URLSearchParams({
          id_token_hint: `${idToken}`,
          post_logout_redirect_uri: `${environment.getSsoLogoutRedirectUri()}`,
        })
        window.location.href = `${url}?${params.toString()}`
      } catch (error) {
        console.log('error logout', error)
      }
    } else {
      localStorage.removeItem('ut')
      localStorage.removeItem('it')
      localStorage.removeItem('ei')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('rn')
      localStorage.removeItem('tt')
      localStorage.removeItem('rt')
      commit('SET_USER_PROFILE', null)
    }
  },

  fetchProfile: async ({ commit }) => {
    const base64UrlDecode = (input: string) => {
      const base64 = input.replace(/-/g, '+').replace(/_/g, '/')
      const padLength = (4 - (base64.length % 4)) % 4
      const padded = base64 + '='.repeat(padLength)
      return Buffer.from(padded, 'base64').toString('utf-8')
    }
    try {
      // const idToken: any = localStorage.getItem('it')
      // console.log('idToken', idToken)
      // const parts = idToken.split('.')
      // if (parts.length !== 3) {
      //   throw new Error('Invalid JWT format')
      // }
      // const payload = base64UrlDecode(parts[1])
      // console.log('user', JSON.parse(payload))
      // const result = JSON.parse(payload)

      const idTokenX: any = localStorage.getItem('ut')
      // console.log('idToken', idTokenX)
      const partsX = idTokenX.split('.')
      if (partsX.length !== 3) {
        throw new Error('Invalid JWT format')
      }
      // console.log('partsX', partsX)

      const payloadX = base64UrlDecode(partsX[1])
      // console.log('userX', JSON.parse(payloadX))
      const resultX = JSON.parse(payloadX)

      localStorage.setItem('userInfo', payloadX)
      localStorage.setItem('rn', resultX?.family_name)
      // console.log('localStorageRn', localStorage.getItem('rn'))
      commit('SET_USER_PROFILE', resultX)
    } catch (error) {
      throw error
    }
  },

  refreshToken: async ({ commit }) => {
    const tokenUrl = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/token`

    const refreshTokenCode = localStorage.getItem('rt')
    const params = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: environment.getSsoClientId(),
      refresh_token: `${refreshTokenCode}`,
    })

    const response = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    })
    // console.log('response', response)
    if (!response.ok) {
      throw new Error('Token exchange failed')
    }
    const result: any = await response.json()

    localStorage.setItem('ut', result.access_token)
    localStorage.setItem('rt', result.refresh_token)
    localStorage.setItem('tt', result.token_type)
    localStorage.setItem('it', result.id_token)
    localStorage.setItem('ei', result.expires_in)
    // window.location.reload()
    return result.access_token
  },

  setToogleChangePasswordDialog: async ({ commit }, data: any) => {
    commit('SET_TOGGLE_CHANGE_PASSWORD_DIALOG', data)
  },
  setToggleMinimizeMenu: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_MINIMIZE_MENU', toggle)
  },
  setToggleDatatableSidebarDeleteButton: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_DATATABLE_SIDEBAR_DELETE_BUTTON', toggle)
  },
  setSearchField: ({ commit }, toggle: boolean) => {
    commit('SET_SEARCH_FIELD', toggle)
  },
  setHeaderButton: async ({ commit }, data: any) => {
    commit('SET_HEADER_BUTTON', data)
  },
  setHeaderButtonActionShowDialogForm: async ({ commit }, data: any) => {
    commit('SET_HEADER_BUTTON_ACTION_SHOW_DIALOG_FORM', data)
  },
  flushHeaderButton: async ({ commit }) => {
    commit('FLUSH_HEADER_BUTTON')
  },
  setShowDialog: ({ commit }: any, showModal: boolean) => {
    commit('SET_SHOW_DIALOG', showModal)
  },
}

export default actions
